import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


export default function ProfileDialog(props) {
    return ( 
        <Stack align='center' sx={{height:'100%', alignItems:'center', justifyContent:'center', }}>
            <TextField onChange={() => 0} inputProps={{ maxLength: 20 }} variant="filled" 
                multiline label="Display Name" sx={{minWidth: '500px', margin: 2,}}/>

            <Button
                onClick={() => 0} variant="contained"
                sx={{ mb: 2 }}
            >
                Save Changes
            </Button>
        </Stack>
    )
}